function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransferPending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.58,122.82l1,.62a26,26,0,0,0,30.57-1.68A27.9,27.9,0,0,0,119,97.33c-.63-5.38-2.82-10.82-1.47-16,1.77-6.79,8.74-10.55,15-13.53s13.27-6.76,15-13.56c1.08-4.26-.23-8.85-2.45-12.67-5.88-10.12-17.89-15.71-29.47-15.61S93,31.16,83.94,38.36c-12.68,10.08-22.11,24.79-24,41S64.44,113.09,77.58,122.82Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261,394.28l.39-1.9c3.26-16-2.26-32.55-14.79-42.76a43,43,0,0,0-5.11-3.58,45.91,45.91,0,0,0-43.34-1.35c-8,4-15.13,10.49-24,11.34-11.51,1.12-19.13-9.22-27.3-17.27s-20.11-15-31.61-13.87c-7.2.73-16.33,5.06-21,10.65-12.32,14.82-11.4,36.86-4.69,54.72s20.92,32.06,37.17,42c22.77,13.89,50.85,20.16,77,13.9S253.34,420.11,261,394.28Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 353.92,
    cy: 374.23,
    r: 20.23,
    transform: "translate(-100.45 616.83) rotate(-74.7)",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M185.33,127.57l-4.42-11.89a29.52,29.52,0,1,0-8.24,6.64h0Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.33,127.57l-12.72-5.12a.11.11,0,0,1-.07-.16l0-.05h0l.15.21a29.5,29.5,0,0,1-14.94,3.65,26.08,26.08,0,0,1-4.66-.52c-.79-.17-1.6-.32-2.4-.52l-2.41-.77a29.79,29.79,0,0,1-19.46-26.73,30.17,30.17,0,0,1,2.44-12.93,29.29,29.29,0,0,1,8.21-11,29.69,29.69,0,0,1,12.55-6.21,30,30,0,0,1,13.41.11A29.07,29.07,0,0,1,176.91,73,29.91,29.91,0,0,1,188,92.31a31.8,31.8,0,0,1-.27,9.7A29.39,29.39,0,0,1,181,115.76l0-.12,4.3,11.93c-.31-.82-1.68-4.38-4.53-11.84a.12.12,0,0,1,0-.13,29.34,29.34,0,0,0,6.55-13.66,31.67,31.67,0,0,0,.22-9.57,29.58,29.58,0,0,0-11-19A28.67,28.67,0,0,0,165.36,68a29.63,29.63,0,0,0-13.19-.1A29.26,29.26,0,0,0,139.84,74a28.6,28.6,0,0,0-8.06,10.8,29.63,29.63,0,0,0-2.42,12.71,29,29,0,0,0,3,11.88,29.47,29.47,0,0,0,16.06,14.49l2.37.77c.8.2,1.59.35,2.37.52a26.39,26.39,0,0,0,4.6.53,29.39,29.39,0,0,0,14.81-3.51.13.13,0,0,1,.18.05.14.14,0,0,1,0,.16h0l0-.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.49,104.57a2.12,2.12,0,1,1-2.12-2.12A2.12,2.12,0,0,1,164.49,104.57Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.33,104.57a2.26,2.26,0,1,1-2.26-2.26A2.26,2.26,0,0,1,158.33,104.57Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.63,100.57a2.4,2.4,0,1,1-2.39-2.4A2.39,2.39,0,0,1,153.63,100.57Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150.25,
    cy: 94.43,
    r: 2.5,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.91,89.05a2.59,2.59,0,1,1-2.59-2.59A2.59,2.59,0,0,1,155.91,89.05Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162,86.93a2.82,2.82,0,1,1-2.82-2.82A2.82,2.82,0,0,1,162,86.93Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.1,100.52a2,2,0,1,1-2-2A2.05,2.05,0,0,1,169.1,100.52Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 168.14,
    cy: 94.36,
    r: 1.9,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.72,89A1.74,1.74,0,1,1,165,87.24,1.74,1.74,0,0,1,166.72,89Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M189.55,436.19l.36,25.39s-27.5,9.8-27.33,15.68l50.8.14-1.75-15.27,2.7-25.4Z",
    style: {
      fill: "#1E1D1D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.43,477.88l-.52-4.61-48.79,1.19a4.18,4.18,0,0,0-1.54,2.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.62,462.34c0,.25,1.26.36,2.49,1.17s1.88,1.86,2.11,1.77-.14-1.55-1.64-2.5S188.56,462.11,188.62,462.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.23,464.55c0,.24,1,.67,1.88,1.73s1.09,2.18,1.34,2.17.41-1.43-.67-2.73S183.24,464.31,183.23,464.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.16,471c.23.06.58-1.19-.06-2.57s-1.81-1.92-1.92-1.71.62.94,1.13,2.08S179.91,471,180.16,471Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.09,456.29c.1.23,1.25-.11,2.67,0s2.51.55,2.65.33-.93-1.11-2.6-1.2S189,456.1,189.09,456.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.08,456.25a1.91,1.91,0,0,1-.25-1,4.82,4.82,0,0,1,.63-2.78,4.41,4.41,0,0,1,.56-.79A1.81,1.81,0,0,1,193,451a.94.94,0,0,1,1.17.63,1.8,1.8,0,0,1-.36,1.26L192.51,455l-.33.55-.18.28a.64.64,0,0,1-.44.35A.7.7,0,0,1,191,456l-.27-.19-.55-.42a18.8,18.8,0,0,1-1.95-1.81c-.29-.32-.56-.64-.82-1a3.11,3.11,0,0,1-.66-1.14.94.94,0,0,1,.12-.77.87.87,0,0,1,.67-.38,1.81,1.81,0,0,1,1.16.37,5.42,5.42,0,0,1,2.39,4.07,2.21,2.21,0,0,1-.09,1,7.37,7.37,0,0,1-.14-1,5.53,5.53,0,0,0-1.08-2.45,4.88,4.88,0,0,0-1.35-1.23,1.38,1.38,0,0,0-.84-.26.35.35,0,0,0-.3.49,2.59,2.59,0,0,0,.57.9q.38.47.81.93A18.65,18.65,0,0,0,190.6,455l.52.4.27.19.09.06s0,.12,0,.09-.07-.1,0-.08l.06-.07.17-.28.33-.54,1.28-2.08a1.35,1.35,0,0,0,.32-.85c0-.2-.3-.32-.54-.26-.51.12-.94.72-1.24,1.16a5.08,5.08,0,0,0-.76,2.55C191,455.88,191.13,456.24,191.08,456.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M213.27,446.9c-1.29.57-2.74-.18-4-.86s-2.8-1.31-4-.53a13.65,13.65,0,0,1-1.21.95c-.87.42-1.88,0-2.8-.34a8.61,8.61,0,0,0-4.64-.21,1,1,0,0,0-.76.49.83.83,0,0,0,.45.88c1.21.75,2.87,0,4.18.53,1,.45,1.73,1.67,2.86,1.75s2.1-1.09,3.24-1a4.81,4.81,0,0,1,1.92,1,4.77,4.77,0,0,0,4.45,0l.27-2.62",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M189.7,458.64a2.71,2.71,0,0,1,3,.33c.52.44,1,1.15,1.7,1s.88-1.13,1.54-1.38c.47-.19,1,.06,1.49,0,1.28-.13,1.73-2,3-2.3.8-.19,1.62.37,2.43.24a3.67,3.67,0,0,0,1.34-.7,1.86,1.86,0,0,1,1.43-.4c.49.13.82.81.46,1.17a1.31,1.31,0,0,1-.71.27,3.72,3.72,0,0,0-2.31,1.52c-.51.74-.84,1.75-1.7,2-.69.2-1.51-.17-2.1.23s-.62,1.37-1.26,1.67-1.4-.34-2.13-.26c-.56.05-1,.53-1.57.64a2,2,0,0,1-1.54-.52,9.38,9.38,0,0,0-1.33-1,1.44,1.44,0,0,0-1.58.05",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M211.91,467.28c.15-.56-.56-1-1.13-.91a3.21,3.21,0,0,0-1.42,1,1.94,1.94,0,0,1-1.53.69,8.41,8.41,0,0,0-1.05-.32c-.6,0-1.06.6-1.66.63s-1.16-.65-1.81-.73-1.35.6-2.08.77c-1.11.25-2.15-.74-3.29-.7s-2.09,1.06-3.19.88a6.24,6.24,0,0,1-1.59-.75,1.28,1.28,0,0,0-1.6.2,1,1,0,0,0,.46,1.4,2.71,2.71,0,0,0,1.62.19,4.36,4.36,0,0,1,1.65,0c.61.16,1.1.63,1.71.77.78.18,1.66-.18,2.37.18s1,1.06,1.65,1c.47,0,.8-.5,1.25-.61.71-.16,1.38.58,2.11.49a3.36,3.36,0,0,0,1.07-.5,4.26,4.26,0,0,1,1.51-.33,19.27,19.27,0,0,1,5.47,0",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M171.26,469.91a.84.84,0,0,1,1.16,0,3.84,3.84,0,0,1,.75,1.06,1.42,1.42,0,0,0,1,.75c.66,0,1.15-.71,1.82-.72s1.1.69,1.71.93a2.59,2.59,0,0,0,1.46,0l2.68-.55a3.48,3.48,0,0,1,1.6-.07,1.17,1.17,0,0,1,.9,1.17c-.08.58-.73.91-1.31.95s-1.17-.11-1.75,0c-.79.11-1.51.64-2.3.58s-1.32-.57-2-.66a19.85,19.85,0,0,0-2.27.29c-.51,0-1-.19-1.51-.17a5,5,0,0,0-1.63.48c-2.35.92-5,.69-7.49.46a18.92,18.92,0,0,1,7.53-4.58",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M189.52,442.66a1.83,1.83,0,0,0,2.7,0c.26-.32.42-.75.8-.93a1.45,1.45,0,0,1,1.31.26,2.16,2.16,0,0,0,1.27.5c.82-.08,1.33-1.16,2.15-1.11.42,0,.76.36,1.18.42.82.12,1.41-.83,2.21-1.06a5.12,5.12,0,0,1,1.41,0,1.21,1.21,0,0,0,1.18-.62.94.94,0,0,0-.32-1,1.83,1.83,0,0,0-1-.36c-1.51-.13-3.11.71-4.51.1-.54-.24-1-.69-1.63-.61s-1,.66-1.59.84c-1,.3-2-.7-3-.42-.36.11-.73.38-1.07.23s-.35-.32-.53-.46-.55-.12-.57.11",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.82,438.27l3.5,25.15s-26.08,13.12-25.19,18.93l50.43-6.13-3.62-14.93-.46-25.54Z",
    style: {
      fill: "#1E1D1D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.68,476.69l-1.1-4.51-48.26,7.21a4.16,4.16,0,0,0-1.19,3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.13,464.33c0,.25,1.3.21,2.62.86s2.1,1.62,2.31,1.49-.33-1.52-1.94-2.28S284.05,464.11,284.13,464.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.06,467.19c0,.25,1.1.54,2.07,1.49s1.35,2,1.6,2,.23-1.47-1-2.63S279,467,279.06,467.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.8,474c.24,0,.43-1.26-.37-2.54s-2-1.69-2.12-1.47.73.86,1.38,1.93S276.55,474,276.8,474Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.85,458.28c.13.21,1.23-.27,2.65-.35s2.56.24,2.67,0-1.06-1-2.73-.88S283.7,458.1,283.85,458.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.82,458s-.24-.3-.37-1a4.84,4.84,0,0,1,.28-2.83,5.07,5.07,0,0,1,.46-.85,1.78,1.78,0,0,1,.84-.75.94.94,0,0,1,1.24.47,1.78,1.78,0,0,1-.2,1.3c-.32.72-.64,1.47-1,2.24l-.26.58-.14.3a.64.64,0,0,1-.4.4.67.67,0,0,1-.53-.1l-.3-.16-.59-.35a16.55,16.55,0,0,1-2.16-1.56c-.33-.27-.64-.56-.94-.85a3,3,0,0,1-.79-1,1,1,0,0,1,0-.78.91.91,0,0,1,.62-.47,1.88,1.88,0,0,1,1.2.23,5.39,5.39,0,0,1,1.59,1.21,5.3,5.3,0,0,1,1.28,2.54,2,2,0,0,1,0,1,7.4,7.4,0,0,1-.26-1,5.64,5.64,0,0,0-1.37-2.3,5.09,5.09,0,0,0-1.5-1.05,1.36,1.36,0,0,0-.86-.16.36.36,0,0,0-.24.53,2.62,2.62,0,0,0,.68.83c.28.27.59.55.91.81a17.54,17.54,0,0,0,2.1,1.5l.56.33.29.16.1.05s0,.12,0,.09-.08-.1,0-.08l0-.08.13-.29.27-.59c.35-.76.69-1.5,1-2.22a1.29,1.29,0,0,0,.21-.88c0-.19-.33-.28-.57-.19a2.63,2.63,0,0,0-1.08,1.3,5.08,5.08,0,0,0-.44,2.63C285.74,457.63,285.87,458,285.82,458Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M306.69,446c-1.21.72-2.74.16-4.05-.36s-2.95-.95-4,0c-.39.33-.65.81-1.08,1.09-.81.53-1.87.2-2.82,0a8.68,8.68,0,0,0-4.63.35c-.3.11-.63.28-.7.59s.24.67.56.81c1.29.6,2.84-.37,4.21,0,1.09.31,1.92,1.45,3,1.38s2-1.35,3.1-1.39a4.84,4.84,0,0,1,2,.73,4.76,4.76,0,0,0,4.41-.56l-.05-2.64",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M284.75,460.53a2.71,2.71,0,0,1,3,0c.57.38,1.17,1,1.81.78s.74-1.23,1.36-1.57c.44-.24,1-.06,1.48-.18,1.26-.29,1.46-2.22,2.68-2.66.77-.27,1.65.18,2.44-.05a3.64,3.64,0,0,0,1.24-.86,1.86,1.86,0,0,1,1.37-.57c.5.06.92.7.6,1.1a1.27,1.27,0,0,1-.67.35,3.7,3.7,0,0,0-2.1,1.8c-.42.8-.62,1.84-1.45,2.19-.66.29-1.52,0-2.06.49s-.44,1.44-1,1.81-1.43-.16-2.14,0c-.55.13-.94.66-1.48.83a2,2,0,0,1-1.59-.32,10,10,0,0,0-1.45-.85,1.45,1.45,0,0,0-1.56.25",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M307.86,466.36c.07-.57-.69-.95-1.24-.76a3.08,3.08,0,0,0-1.28,1.13,2,2,0,0,1-1.44.87,6.88,6.88,0,0,0-1.09-.18c-.59.06-1,.72-1.57.82s-1.22-.5-1.88-.5-1.26.76-2,1c-1.07.39-2.23-.47-3.35-.29s-1.94,1.31-3.06,1.27a6.06,6.06,0,0,1-1.67-.55c-.55-.18-1.3-.13-1.56.4a1,1,0,0,0,.63,1.33,2.67,2.67,0,0,0,1.63,0,4.39,4.39,0,0,1,1.64-.21c.62.09,1.16.49,1.79.56.79.08,1.62-.38,2.37-.11s1.12.93,1.77.79c.45-.1.72-.6,1.16-.76.69-.26,1.44.4,2.15.22a3.48,3.48,0,0,0,1-.63,4.25,4.25,0,0,1,1.45-.51,18.91,18.91,0,0,1,5.43-.64",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M267.84,474a.84.84,0,0,1,1.15-.17,4.2,4.2,0,0,1,.88.95,1.36,1.36,0,0,0,1.08.62c.66,0,1.07-.84,1.72-.93s1.18.55,1.82.71a2.57,2.57,0,0,0,1.44-.2l2.59-.88a3.47,3.47,0,0,1,1.58-.26,1.16,1.16,0,0,1,1,1.05c0,.58-.61,1-1.18,1.1s-1.17,0-1.74.19c-.77.2-1.42.81-2.22.85s-1.37-.4-2.08-.4-1.45.49-2.22.57c-.5.06-1-.06-1.51,0a5.06,5.06,0,0,0-1.56.69c-2.23,1.19-4.85,1.3-7.38,1.37a19.06,19.06,0,0,1,6.9-5.47",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M282.59,444.69a1.82,1.82,0,0,0,2.68-.36c.22-.35.33-.8.68-1a1.41,1.41,0,0,1,1.33.1,2.2,2.2,0,0,0,1.33.33c.8-.18,1.17-1.31,2-1.36.42,0,.8.26,1.22.27.84,0,1.3-1,2.07-1.32a5,5,0,0,1,1.4-.2,1.19,1.19,0,0,0,1.08-.76.91.91,0,0,0-.43-.93,1.75,1.75,0,0,0-1.05-.23c-1.52.05-3,1.08-4.47.65-.57-.17-1.12-.55-1.69-.41s-.93.79-1.48,1c-.94.41-2.07-.45-3-.05-.34.15-.67.46-1,.36s-.38-.27-.59-.39-.55-.05-.55.18",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M258.33,129a95.29,95.29,0,0,0,4.42-24.18l2-4.63c2.83-3.19,7.94-3.69,11.75-1.79s6.36,5.79,7.48,9.9a33.87,33.87,0,0,1,.45,12.7c-.31,2.75-.58,6,1.52,7.82.74.65,1.71,1,2.38,1.73a3.71,3.71,0,0,1-.28,4.94,5.11,5.11,0,0,1-5.09,1,5.17,5.17,0,1,1-10,2.52,5.4,5.4,0,0,1-4.51,3.46,10.06,10.06,0,0,1-5.78-1.24c-2.4-1.19-4.67-3.12-5.24-5.74C256.89,133.34,257.65,131.11,258.33,129Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.78,142.65a1,1,0,0,0,.49.08,2.48,2.48,0,0,0,1.36-.47,3.21,3.21,0,0,0,1.28-1.9,5.48,5.48,0,0,0-.24-3,29.47,29.47,0,0,0-1.52-3.28,12.12,12.12,0,0,1-1.07-3.89,28.28,28.28,0,0,1,1-9.27,31.28,31.28,0,0,0,1.15-9.43,10.71,10.71,0,0,0-3-7.08,7.59,7.59,0,0,0-4.74-2.16,4.11,4.11,0,0,0-1.9.25,9.7,9.7,0,0,1,1.89,0,7.59,7.59,0,0,1,4.48,2.22,10.45,10.45,0,0,1,2.81,6.85,31.66,31.66,0,0,1-1.18,9.27,27.71,27.71,0,0,0-1,9.45,12.14,12.14,0,0,0,1.16,4,35.73,35.73,0,0,1,1.56,3.22,5.24,5.24,0,0,1,.3,2.82,3.07,3.07,0,0,1-1.1,1.79A2.69,2.69,0,0,1,276.78,142.65Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.63,106.41a13.3,13.3,0,0,0-1.56-4.62,5.54,5.54,0,0,0-3.9-2.7,3.52,3.52,0,0,0-3.78,2.43l.93-.74a15.08,15.08,0,0,0-3,11.3c.39,2.69,1.87,5.56,4.5,6.22s5.41-1.31,6.48-3.83S271.13,109.09,270.63,106.41Z",
    style: {
      fill: "#1E1D1D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266,113a4,4,0,0,0,2.53.55,5.22,5.22,0,0,0,1.81-.4c.47-.18.61-.53.56-.54a2.23,2.23,0,0,1-.64.32,7.38,7.38,0,0,1-1.75.29A16.31,16.31,0,0,1,266,113Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.69,108.21a14.67,14.67,0,0,0,3.07.07,13.94,13.94,0,0,0,3.06-.27,27.73,27.73,0,0,0-6.13.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.71,103.13a8.5,8.5,0,0,0,2.06-.13,5,5,0,0,1,1.41.08c.35.08.57.17.59.12s-.15-.2-.52-.34a3.51,3.51,0,0,0-1.5-.19A5.52,5.52,0,0,0,265.71,103.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.21,90.29c.07-2.68-2.41-4.75-4.9-5.74s-5.28-1.35-7.5-2.85c-2-1.32-3.3-3.39-5-5.08a16.51,16.51,0,0,0-27.77,7.57c-1,3.82-.31,8.34,2.7,10.88,3.5,2.94,8.68,2.29,13.16,1.37s9.54-1.82,13.28.81c2.26,1.59,3.55,4.17,4.93,6.55s3.1,4.83,5.71,5.73,6.15-.66,6.25-3.41",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259,91.76c-.3,2.25,1.33,4.26,3,5.85s3.45,3.27,3.73,5.52c.34,2.63-1.58,5.22-1,7.8.36,1.65,1.64,2.91,2.41,4.41a9.32,9.32,0,0,1,.48,6.89c-.67,2.26-1.73,7.32-3.31,9.08a36.34,36.34,0,0,1-17.64,10.52c-6.36,1.47-13,1.47-19.49,1.07-5.33-.32-11.46-.08-15.91-7.42-2.3-3.8-3.44-8.85-4.66-13.12-1.06-3.68-2-7.62-.87-11.29.63-2.13,1.92-4,2.55-6.17.78-2.67.5-5.53.81-8.29a19,19,0,0,1,27.08-15",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.61,101c.5-7.65,5.59-17,13.21-16.21l23.81,6.07a4.49,4.49,0,0,1,4,4.56L250,151.56a7.75,7.75,0,0,1-.66,2.77c-1.77,3.9-7.65,13.8-20.4,9.79-3.12-1-4.55-4.4-5.17-7.91,0-.42-.17-.78-.18-1.18a38.22,38.22,0,0,1-.09-7.89c0-4.63,0-6.54,0-6.49S213.7,139,211.7,126.24C210.71,119.89,211.05,109.48,211.61,101Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215,110.23a1.63,1.63,0,0,0,1.57,1.65,1.57,1.57,0,0,0,1.69-1.47,1.64,1.64,0,0,0-1.57-1.66A1.57,1.57,0,0,0,215,110.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.85,110.23a1.64,1.64,0,0,0,1.58,1.65,1.57,1.57,0,0,0,1.69-1.47,1.64,1.64,0,0,0-1.57-1.66A1.58,1.58,0,0,0,231.85,110.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.48,107c.26.11,1.52-.78,3.51-1.14s3.58,0,3.77-.21-.21-.3-.91-.47a7.86,7.86,0,0,0-3.06,0,7,7,0,0,0-2.75,1.1C231.5,106.66,231.35,107,231.48,107Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.15,105.83c.22.19,1.69-.26,3.69,0s3.41,1.11,3.64,1-.09-.35-.71-.73a7.61,7.61,0,0,0-2.9-1,7.11,7.11,0,0,0-3,.17C214.28,105.51,214,105.75,214.15,105.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.74,119.81a11.6,11.6,0,0,0-2.86-.52c-.45-.05-.87-.14-.95-.45a2.4,2.4,0,0,1,.3-1.33l1.34-3.42c1.86-4.87,3.21-8.88,3-9s-1.86,3.82-3.72,8.69c-.45,1.2-.88,2.34-1.28,3.44a2.59,2.59,0,0,0-.24,1.76,1.12,1.12,0,0,0,.74.66,2.84,2.84,0,0,0,.76.11A11.45,11.45,0,0,0,224.74,119.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.48,140.65a32.5,32.5,0,0,0,17.1-4.52s-4.32,8.82-17.09,7.6Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.48,124.06a3.15,3.15,0,0,1,2.84-1.18,2.92,2.92,0,0,1,2,1.08,1.85,1.85,0,0,1,.14,2.1,2.13,2.13,0,0,1-2.31.58,6.66,6.66,0,0,1-2.25-1.35,1.9,1.9,0,0,1-.5-.52.59.59,0,0,1,0-.66",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.92,121c-.29,0-.29,1.89-1.93,3.25s-3.68,1.14-3.69,1.4.45.38,1.31.4a4.8,4.8,0,0,0,3.08-1.06,4.16,4.16,0,0,0,1.5-2.73C230.26,121.5,230.05,121,229.92,121Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.51,102.5c.18.48,1.93.25,4,.51s3.73.82,4,.39c.12-.21-.17-.66-.84-1.12a6.63,6.63,0,0,0-3-1,6.73,6.73,0,0,0-3.13.36C230.82,101.89,230.44,102.27,230.51,102.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.51,101.3c.31.4,1.52,0,3,0s2.7.28,3-.14c.13-.2-.07-.6-.61-1a4.31,4.31,0,0,0-4.8.14C214.54,100.7,214.37,101.11,214.51,101.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.71,82.65A15.5,15.5,0,0,0,226,99.78c.15-1.58.31-3.17.46-4.76,2,3.61,6.38,4.91,10.31,6.1s8.3,3.11,9.44,7.06c.88,3-.53,6.36.11,9.47.34,1.69,1.27,3.21,1.72,4.87.65,2.44.25,5,.71,7.54s2.36,5.1,4.88,4.9a4.63,4.63,0,0,0,3.59-2.85,13.57,13.57,0,0,0,.89-4.7c.43-6.52.73-13.07.51-19.61-.2-5.67-.91-11.66-4.37-16.16-3.79-4.93-10.15-7.1-16.27-8.26s-12.46-1.59-18.14-4.15",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.77,93.5c.16-.1-2.38-3.06-3.46-7.6a27,27,0,0,1-.44-8.33,7.31,7.31,0,0,0-.52,2.44,18.14,18.14,0,0,0,2.83,11.56A8,8,0,0,0,222.77,93.5Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257,119a5.39,5.39,0,0,0,.28-.61c.17-.4.39-1,.64-1.81a21.78,21.78,0,0,0,.92-7,17.13,17.13,0,0,0-3.4-9.83,14.59,14.59,0,0,0-4.71-4.06,18.82,18.82,0,0,0-6.4-1.86c-2.26-.3-4.47-.42-6.57-.72a21.29,21.29,0,0,1-5.85-1.62,21.88,21.88,0,0,1-11.49-12.31l-.37-1-.21-.78a3.94,3.94,0,0,0-.21-.63,2.54,2.54,0,0,0,.1.66c.05.23.11.49.17.79s.2.67.32,1.06a20.09,20.09,0,0,0,3.32,6.22,21.62,21.62,0,0,0,8.17,6.49,21.25,21.25,0,0,0,6,1.68c2.13.32,4.35.44,6.58.74a18.38,18.38,0,0,1,6.22,1.79,14.15,14.15,0,0,1,4.57,3.9,17,17,0,0,1,3.41,9.54,22.94,22.94,0,0,1-.75,6.91c-.21.8-.4,1.42-.53,1.83A2.6,2.6,0,0,0,257,119Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.62,104.23a1.94,1.94,0,0,0,0-.57,15,15,0,0,0-.15-1.65A17.15,17.15,0,0,0,250.24,88c-1.82-.42-3.75-.42-5.63-.76A6.36,6.36,0,0,1,240,84.53a19.53,19.53,0,0,1-1.24-2.35,15,15,0,0,0-1.31-2.28,15.67,15.67,0,0,0-7.05-5.52,15,15,0,0,0-6-1,10.09,10.09,0,0,0-1.64.18,1.68,1.68,0,0,0-.56.13c0,.06.78-.11,2.2-.1a15.58,15.58,0,0,1,12.6,6.63,15.36,15.36,0,0,1,1.25,2.22,20.1,20.1,0,0,0,1.27,2.42,5.82,5.82,0,0,0,2.11,2,8.9,8.9,0,0,0,2.8.94c2,.34,3.86.34,5.62.74A17.15,17.15,0,0,1,255,90.34a16.75,16.75,0,0,1,6.21,6.14,17.92,17.92,0,0,1,2.11,5.57C263.55,103.44,263.57,104.23,263.62,104.23Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.08,140a3.48,3.48,0,0,0,.57.58l0,0h0a19.83,19.83,0,0,0,6.75-4.54,33.16,33.16,0,0,0,4.15-5.24,10.09,10.09,0,0,1,1.17-1.37c.45-.41,1-.78,1.48-1.18a7.64,7.64,0,0,0,2.61-3.13,9.47,9.47,0,0,0,.72-4.74,11.73,11.73,0,0,0-1.27-4.28c-.66-1.25-1.43-2.34-1.9-3.46a5.81,5.81,0,0,1-.39-3.27c.15-1,.43-2,.62-2.77a10.85,10.85,0,0,0,.34-2.15,4.81,4.81,0,0,0-.14-1.37,1.48,1.48,0,0,0-.17-.45,7.29,7.29,0,0,1,.09,1.81,11.35,11.35,0,0,1-.41,2.09c-.22.8-.52,1.72-.71,2.78a6.07,6.07,0,0,0,.36,3.5c.47,1.19,1.24,2.3,1.87,3.52a11.62,11.62,0,0,1,1.18,4.1,9,9,0,0,1-.68,4.47,7.19,7.19,0,0,1-2.44,2.93,19.32,19.32,0,0,0-1.52,1.22,10.39,10.39,0,0,0-1.23,1.45,33.89,33.89,0,0,1-4,5.24,22.35,22.35,0,0,1-6.49,4.71l.07,0A3.75,3.75,0,0,0,251.08,140Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.29,180l14.82,17.12-1.6,4.68L200,210.52s-2.78,1.47-7.39-6.86-9.12-23.59-9.12-23.59Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.22,141.73a1.77,1.77,0,0,1,1.61-.63l10.35,1.42a3.21,3.21,0,0,1,2.21,1.43l21.5,33-1.66.92-11.44-.36L166.9,142.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.55,146a.74.74,0,0,1-.94-1.06.65.65,0,0,1,.87.18A.63.63,0,0,1,174.55,146Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.9,142.14a12.64,12.64,0,0,0,2,.39l5.48.85,3.79.56a2.12,2.12,0,0,1,1.6.94l1.23,1.9,5.49,8.46c3.91,6,7.47,11.4,10.08,15.3l3.12,4.6a14.43,14.43,0,0,0,1.21,1.64,10.84,10.84,0,0,0-1-1.77c-.75-1.2-1.74-2.79-2.95-4.71-2.51-4-6-9.4-9.93-15.4l-5.53-8.43c-.43-.65-.85-1.28-1.25-1.9a2.68,2.68,0,0,0-2-1.14l-3.81-.48-5.52-.66A11.33,11.33,0,0,0,166.9,142.14Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.38,154s.92-.17,1.43,2.36,2.13,9.76,2.13,9.76l4.83-2.57,6,.79s1.32,1.22.35,1.88-4.79,1.34-4.79,1.34l-2.82,4.06,8.09-3.9s2.7.7,1.91,2.35-6.25,6.8-6.25,6.8l4.06-.31,4.82-2.92s1.48.06.92,1.32-5.56,5.81-5.56,5.81l-6.08,2.95s-3.32-.26-3.63-1.23a11.39,11.39,0,0,1-.4-2.37s-1.76-.47-2.09-1.33a5.28,5.28,0,0,1-.12-2.2s-2.77.48-3.11-1.06a17.85,17.85,0,0,1,.22-5.76c.28-1.19-1.17-12.21-1.06-12.54S176.64,153.22,178.38,154Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.62,182.45a3.37,3.37,0,0,0,1.59.49,10.6,10.6,0,0,0,4-.18,10.73,10.73,0,0,0,3.65-1.64c.84-.61,1.25-1.1,1.2-1.16s-2,1.52-5,2.19S183.66,182.26,183.62,182.45Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.06,180.27c.1.14,1.17-.42,2.32-1.37s1.92-1.89,1.8-2-1.06.61-2.19,1.53S185,180.13,185.06,180.27Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.87,175c.09.14,1.16-.41,2.23-1.41s1.72-2,1.59-2.12-1,.7-2,1.66S181.77,174.88,181.87,175Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.5,170.8c.17.07.78-1.07,1.74-2.31s1.9-2.14,1.79-2.28-1.27.57-2.28,1.9A4.73,4.73,0,0,0,178.5,170.8Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.43,293s-26.93,52.71-30.72,68.63-2.41,86.46-2.41,86.46h30.82a259.63,259.63,0,0,1,2.31-37.16c2.65-17.82,4.7-31.09,2.73-36.4s6.64-7.21,7.26-8.73S260.69,310,260.69,310L250,279.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.94,355.05a102.33,102.33,0,0,1,4,9.5,101.55,101.55,0,0,1,3.48,9.68,99.16,99.16,0,0,1-4-9.5A98.32,98.32,0,0,1,214.94,355.05Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.68,296.61s27.31,80,30,83.05,16.81,72.8,16.81,72.8l25.28-1.89s3.79-48.54,0-63.33-13.65-39.44-15.92-58.78.75-30.09,0-42.73-4.18-18.83-4.18-18.83L235.68,289Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.76,305.69a4.18,4.18,0,0,1,.33.75c.21.55.5,1.28.85,2.2.74,2,1.77,4.74,3,8.14,2.53,6.88,5.94,16.42,9.7,27s7.2,20.06,9.76,26.93c1.27,3.4,2.31,6.16,3.05,8.13l.81,2.21a5.25,5.25,0,0,1,.26.79,4.47,4.47,0,0,1-.35-.75c-.23-.54-.53-1.27-.91-2.18-.78-1.89-1.88-4.65-3.2-8.07-2.65-6.84-6.15-16.35-9.91-26.88s-7.09-20.05-9.55-27c-1.2-3.43-2.18-6.21-2.88-8.2l-.76-2.23A4.29,4.29,0,0,1,238.76,305.69Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.69,281.39a2.92,2.92,0,0,1-.55.69,13.81,13.81,0,0,1-1.82,1.57,15.73,15.73,0,0,1-15.13,1.89,12.61,12.61,0,0,1-2.14-1.08,2.68,2.68,0,0,1-.71-.53c.05-.08,1.1.61,3,1.27a16.5,16.5,0,0,0,14.79-1.85C283.77,282.25,284.62,281.33,284.69,281.39Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.58,196.92l10.78-15.27,5,6.38,12.72,10.83-9.63,37.82-7.53-7.57s-7.51-21.56-7.84-25.84Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.36,151.37c6,1.27,15.78-1.57,27.11-6.14l-8.57,32.22-35.43,63.74,2.4-56.69Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223,151.76s-14.3,23.36-15.43,26-4,14.45-5.49,22.86-3.68,33.55-3.72,50.25c0,20.08.58,37,.58,37l11.93,6.48s-1.36-71.85-.83-75.7-.5-11.28.83-22.16a60,60,0,0,1,5.23-18.82c1.77-4.11,6.08-17.66,6.9-22.79S223,151.76,223,151.76Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.89,146.52l-21.2-2.06-24.44,22.67s-17.5,39.08-19.1,71.62c-1.58,32.06,3.2,67.94,4.38,67.94s88-39.75,88-39.75l-5-24.44-12.95-86.56S277.86,147.1,271.89,146.52Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.17,219s-.3-13.54-3.54-20-27.42-47.17-27.42-47.17S246.86,173,261,214.24l4.72,1.47s-2.95,2.06-2.36,5c0,0-8-.59-10.33,4.85,0,0-3.51-.14-5.57,1.62s-12.66,13.36-12.66,13.36,10.89,19,14.72,19.33,1.47,0,1.47,0l10.6-7.95s15.61,2.65,23,.29,12.37-8.63,15-11.67S310.6,225.38,310.17,219Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.27,222.83a33.81,33.81,0,0,0-7.56-4.93c-4.61-2-8.79-2.08-8.75-2.27a9.8,9.8,0,0,1,2.69.09,22.64,22.64,0,0,1,6.27,1.7,21.81,21.81,0,0,1,5.49,3.47A8.69,8.69,0,0,1,282.27,222.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.33,202.41a4.23,4.23,0,0,1-1,.51l-2.8,1.25c-2.35,1.06-5.58,2.59-9,4.46s-6.53,3.72-8.71,5.11l-2.58,1.64a4.57,4.57,0,0,1-1,.56,5.08,5.08,0,0,1,.86-.72c.58-.45,1.43-1.06,2.5-1.79a96.73,96.73,0,0,1,8.66-5.26,97.85,97.85,0,0,1,9.16-4.34c1.2-.49,2.18-.86,2.87-1.1A4.78,4.78,0,0,1,290.33,202.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.27,235.44a25.48,25.48,0,0,0-5.43-6.2,25.76,25.76,0,0,0-7.38-3.69,7.26,7.26,0,0,1,2.42.49,17.4,17.4,0,0,1,9.31,7.18A7.53,7.53,0,0,1,264.27,235.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260,252.2c-.07,0-.82-1.3-2.1-3.41s-3.12-5-5.34-8-4.39-5.67-6-7.53-2.66-3-2.6-3a5,5,0,0,1,.81.71c.51.47,1.21,1.19,2.06,2.09a83,83,0,0,1,6.17,7.47,85.08,85.08,0,0,1,5.23,8.15c.6,1.09,1.06,2,1.36,2.6A4.47,4.47,0,0,1,260,252.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.1,251.14s.1-.16.4-.27a1.9,1.9,0,0,1,1.32,0,1.86,1.86,0,0,1,1.25,1.53,2.1,2.1,0,0,1-1.16,2.13,2,2,0,0,1-2.34-.64,1.81,1.81,0,0,1,.92-2.8c.31-.08.48,0,.48,0a2.19,2.19,0,0,0-1.18,1,1.35,1.35,0,0,0,.16,1.5,1.58,1.58,0,0,0,1.75.46,1.62,1.62,0,0,0,.89-1.6,1.52,1.52,0,0,0-.91-1.24A2.55,2.55,0,0,0,249.1,251.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.36,289.81a19.52,19.52,0,0,1-3.76-3.56,31.87,31.87,0,0,1-6.24-12.61A49.66,49.66,0,0,1,216,264a98.74,98.74,0,0,1,.17-11.2,245.88,245.88,0,0,1,15.07-70.42,180.91,180.91,0,0,1,7.55-17.75,1.46,1.46,0,0,1-.12.32c-.09.23-.22.53-.38.92l-1.52,3.52L234.42,175c-.84,2.21-1.88,4.7-2.87,7.51a253.93,253.93,0,0,0-11.92,44.9,247,247,0,0,0-3,25.42A100.75,100.75,0,0,0,216.4,264a49.88,49.88,0,0,0,1.32,9.6,32.48,32.48,0,0,0,6,12.57,28.66,28.66,0,0,0,2.62,2.79l.74.66A1.86,1.86,0,0,1,227.36,289.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297,254.43s-.07,0-.21.13l-.67.34-2.55,1.26c-2.23,1.09-5.42,2.71-9.35,4.74l-13.78,7.22c-5.2,2.7-10.92,5.66-17.06,8.51s-11.83,5.81-17,8.53-9.82,5.23-13.71,7.34l-9.21,5-2.51,1.35-.66.34-.23.11s.06-.06.2-.15l.64-.39,2.46-1.44c2.15-1.23,5.26-3,9.13-5.16s8.5-4.68,13.67-7.44,10.89-5.72,17-8.58,11.85-5.78,17.06-8.46l13.83-7.11c3.95-2,7.18-3.57,9.43-4.61,1.12-.52,2-.91,2.6-1.17l.68-.29A1,1,0,0,1,297,254.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.2,278.35c-.16,0-.74-2.41-1.72-5.32s-2-5.21-1.86-5.28a19,19,0,0,1,2.35,5.11A19.52,19.52,0,0,1,274.2,278.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.72,267.52s.13-.14.47-.2a1.9,1.9,0,0,1,1.36.34,1.83,1.83,0,0,1,.77,1.94,2,2,0,0,1-3.95,0,1.87,1.87,0,0,1,.74-2,1.94,1.94,0,0,1,1.35-.4c.33,0,.49.16.48.18a2.39,2.39,0,0,0-1.6.51,1.47,1.47,0,0,0-.5,1.55,1.54,1.54,0,0,0,3,0,1.48,1.48,0,0,0-.53-1.53A2.34,2.34,0,0,0,277.72,267.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.2,285a3,3,0,0,1-.5-.37c-.31-.27-.8-.63-1.36-1.17a39.1,39.1,0,0,1-4.45-4.86,44.73,44.73,0,0,1-5.16-8.31,33.79,33.79,0,0,1-2.73-23.4,37.8,37.8,0,0,1,3.42-9.16,34.15,34.15,0,0,1,3.63-5.51,17.77,17.77,0,0,1,1.17-1.35,3.25,3.25,0,0,1,.44-.45s-.52.69-1.45,1.93a37.25,37.25,0,0,0-3.46,5.55,38.59,38.59,0,0,0-3.28,9.09,33.86,33.86,0,0,0,2.69,23.1,46.58,46.58,0,0,0,5,8.28,43,43,0,0,0,4.3,4.94C235.58,284.37,236.23,284.93,236.2,285Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.25,167.13,241,149.46,251,140l7.66,2.06L242.44,166s-2.35-4.12-6.18-3.83S226.25,167.13,226.25,167.13Z",
    style: {
      fill: "#1E1D1D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.42,144.88a11,11,0,0,1-.88,1.53c-.6,1-1.48,2.35-2.6,4-2.25,3.37-5.49,8-9.3,12.83l-2.46,3.09-.3.37-.14-.46a4.94,4.94,0,0,0-2.28-2.71,7.26,7.26,0,0,0-3.23-.93,10.87,10.87,0,0,0-5.48,1.45,26.13,26.13,0,0,0-3.23,2.1,7.78,7.78,0,0,1-1.15.82,7.56,7.56,0,0,1,1-1,21.11,21.11,0,0,1,3.19-2.25,10.92,10.92,0,0,1,5.67-1.61,7.68,7.68,0,0,1,3.45,1,5.42,5.42,0,0,1,2.52,3l-.45-.09,2.45-3.08c3.81-4.87,7.08-9.4,9.4-12.72l2.74-3.94A12.07,12.07,0,0,1,257.42,144.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.57,240.55s-.16.21-.5.61-.82,1-1.49,1.77a39.38,39.38,0,0,1-6.42,6,23.15,23.15,0,0,1-5.53,3.05,24.24,24.24,0,0,1-7.33,1.36,102.77,102.77,0,0,1-17.93-.94l.16,0L251,259.63l0,0h0l-1.29.44-.06,0h0a5.18,5.18,0,0,1-2.54-1.57,27.8,27.8,0,0,1-2-2.2c-1.27-1.54-2.45-3.18-3.62-4.88-2.33-3.4-4.58-7-6.77-10.79l-.1-.16.13-.14c3.9-4.21,7.89-8.64,12.24-13a6.49,6.49,0,0,1,2.91-1.66,11.33,11.33,0,0,1,3.28-.43l-.25.16a7.79,7.79,0,0,1,1.88-2.56,9.8,9.8,0,0,1,2.71-1.56,15.42,15.42,0,0,1,6-.89l-.27.31a4.59,4.59,0,0,1,.49-3,7.27,7.27,0,0,1,2-2.26l.07.45-4.71-1.47-.12,0,0-.12A68.76,68.76,0,0,1,257.51,200a53.86,53.86,0,0,1,.24-13.42A50.11,50.11,0,0,1,260.86,175a53.72,53.72,0,0,1,4.76-9.07,55.67,55.67,0,0,1,9.47-11c1.27-1.12,2.3-1.93,3-2.45.36-.26.63-.45.82-.57a2.82,2.82,0,0,1,.29-.18s-.08.07-.26.21l-.8.61c-.69.54-1.7,1.37-2.95,2.51a56.29,56.29,0,0,0-9.32,11,54.06,54.06,0,0,0-4.68,9,50.58,50.58,0,0,0-3,11.45,53.54,53.54,0,0,0-.19,13.31,68.43,68.43,0,0,0,3.25,14.22l-.16-.16,4.71,1.47.47.15-.4.3c-1.43,1.08-2.64,2.89-2.25,4.75l.07.31h-.34a15.08,15.08,0,0,0-5.78.86,9.29,9.29,0,0,0-2.55,1.48,7.18,7.18,0,0,0-1.74,2.37l-.08.15H253c-2.06,0-4.33.42-5.82,1.95-4.3,4.29-8.32,8.73-12.21,12.94l0-.3c2.18,3.76,4.43,7.37,6.74,10.76,1.16,1.7,2.34,3.33,3.58,4.86a23.71,23.71,0,0,0,2,2.15,4.84,4.84,0,0,0,2.24,1.45h-.09l1.29-.43-.07,0,9.61-7.23.07-.06h.09a103.49,103.49,0,0,0,17.85,1,23.86,23.86,0,0,0,7.24-1.29,23.57,23.57,0,0,0,5.5-3,40.72,40.72,0,0,0,6.46-5.9l1.54-1.72C299.37,240.73,299.57,240.55,299.57,240.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.25,167.13a1.89,1.89,0,0,1-.11.33l-.38.95c-.36.86-.87,2.08-1.51,3.63l-1.1,2.62c-.37,1-.76,2-1.19,3.16-.84,2.28-1.87,4.84-2.77,7.76-.48,1.45-1,3-1.5,4.55s-.95,3.26-1.46,5c-1,3.43-1.91,7.17-2.88,11.08A256.75,256.75,0,0,0,208.9,232c-1,9.26-1.5,18.13-1.63,26.19,0,4,0,7.87.16,11.46.08,1.79.11,3.52.21,5.19s.22,3.25.32,4.78c.17,3,.5,5.79.73,8.2.12,1.2.24,2.33.34,3.36s.26,2,.37,2.82c.21,1.67.38,3,.5,3.9l.11,1a1.52,1.52,0,0,1,0,.35A1.49,1.49,0,0,1,210,299c0-.26-.1-.59-.17-1-.14-.93-.34-2.23-.59-3.89-.13-.85-.26-1.79-.42-2.82s-.24-2.15-.38-3.36c-.26-2.41-.61-5.15-.8-8.21-.12-1.52-.24-3.12-.37-4.78s-.15-3.4-.23-5.2c-.2-3.59-.17-7.43-.21-11.47.1-8.08.55-17,1.59-26.25a249,249,0,0,1,4.51-25.9c1-3.92,1.86-7.66,2.93-11.09.51-1.72,1-3.4,1.48-5s1-3.09,1.54-4.54c.93-2.91,2-5.47,2.85-7.74.44-1.13.83-2.19,1.23-3.15s.8-1.82,1.14-2.61l1.6-3.59.43-.93A1.44,1.44,0,0,1,226.25,167.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223,151.76a2.79,2.79,0,0,1-.26.54l-.85,1.53-3.23,5.69-11.3,19.53,0-.05c-1.09,3.69-2.09,7.73-3,11.95a272.33,272.33,0,0,0-4.56,30.59c-.38,3.94-.56,7.14-.7,9.35-.05,1.07-.1,1.92-.13,2.55a4.86,4.86,0,0,1-.08.89,6.1,6.1,0,0,1,0-.89c0-.63,0-1.48,0-2.56.08-2.21.2-5.42.53-9.37a248.48,248.48,0,0,1,4.42-30.67c.9-4.23,1.9-8.28,3-12v-.06c4.61-7.82,8.6-14.58,11.45-19.44l3.37-5.61.91-1.49A2.92,2.92,0,0,1,223,151.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203,188a11.16,11.16,0,0,1-1,2.67,30.34,30.34,0,0,1-8.41,10.78,10.56,10.56,0,0,1-2.35,1.6,26.38,26.38,0,0,1,2.12-1.88,37.37,37.37,0,0,0,8.31-10.66A25.07,25.07,0,0,1,203,188Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.08,196.53c-.07,0,.22-.5,1-.39a1.1,1.1,0,0,1,.88.85,1.23,1.23,0,0,1-2.1,1.11,1.14,1.14,0,0,1-.26-1.19c.26-.68.79-.74.78-.67s-.33.25-.43.76a.81.81,0,0,0,.24.75.86.86,0,0,0,.91.15.85.85,0,0,0,.39-.82.73.73,0,0,0-.5-.58C191.45,196.33,191.13,196.59,191.08,196.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242,258.74l3-2.4s-8.52-11-9.82-15.15C235.14,241.19,237.78,251.84,242,258.74Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.17,270.9a6.41,6.41,0,0,1-.68-1.11c-.46-.83-1-1.88-1.71-3.13-1.42-2.65-3.37-6.32-5.34-10.48a94.56,94.56,0,0,1-4.39-10.92c-.46-1.44-.8-2.61-1-3.43a6,6,0,0,1-.26-1.28,6.18,6.18,0,0,1,.46,1.22c.25.8.64,1.95,1.15,3.37,1,2.83,2.56,6.67,4.52,10.82s3.85,7.84,5.19,10.53c.67,1.35,1.2,2.44,1.56,3.2A6.23,6.23,0,0,1,248.17,270.9Z",
    style: {
      fill: "#263238"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransferPending);
export default __webpack_public_path__ + "static/media/transfer_pending.dc87cea851a4abf9af12126737ec288f.svg";
export { ForwardRef as ReactComponent };